module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day01_02_stay-e8d9d88ca5aa632f432fab9a1cdb24ed.jpg";